module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words4.9f4ab56e.jpg";